import { createContext } from 'react';

import type { BackgroundColor } from '../constants';

export const BlockBackgroundColorContext = createContext<BackgroundColor | undefined>(undefined);
